import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BrokerStylingService } from './broker-styling.service';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2,
    private brokerService: BrokerStylingService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public loadCookieScripts(): Promise<void> {
    return new Promise((resolve) => {
    
      const broker = this.brokerService.getBrokerDetailFromDomain();

      if (broker.domain === 'hfq.quotedevil.ie' || broker.domain === 'uat-hfq.quotedevil.ie' ) {
        this.insertQuoteDevilIrelandsScripts();
      } else if (broker.domain === 'hfq.chill.ie' || broker.domain === 'uat-hfq.chill.ie') {
        this.insertChillScripts();
      } else if (broker.domain === 'localhost') {

        if(broker.brokerId == '01')
          this.insertChillScripts();
        else if(broker.brokerId == '04')
          this.insertQuoteDevilIrelandsScripts();
      }

      resolve();
    });
  }

  private insertQuoteDevilScripts(): void {
    // OtAutoBlock.js
    const script1 = this.renderer.createElement('script');
    script1.type = 'text/javascript';
    script1.src = 'https://cdn.cookielaw.org/consent/80e2118e-beb7-4ce1-8498-ebe53e0f1956/OtAutoBlock.js';
    this.renderer.appendChild(this.document.head, script1);

    // otSDKStub.js
    const script2 = this.renderer.createElement('script');
    script2.type = 'text/javascript';
    script2.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script2.charset = 'UTF-8';
    script2.setAttribute('data-domain-script', '80e2118e-beb7-4ce1-8498-ebe53e0f1956');
    this.renderer.appendChild(this.document.head, script2);

    // OptanonWrapper function
    const inlineScript = this.renderer.createElement('script');
    inlineScript.type = 'text/javascript';
    inlineScript.innerHTML = `function OptanonWrapper() { }`;
    this.renderer.appendChild(this.document.head, inlineScript);
  }

private insertQuoteDevilIrelandsScripts(): void {
  // otSDKStub.js
  const script2 = this.renderer.createElement('script');
  script2.type = 'text/javascript';
  script2.src =
    'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js';
  script2.charset = 'UTF-8';
  script2.setAttribute('data-domain-script', '019add7a-d385-737f-bab7-1519ebef10a6');
  script2.setAttribute('data-language', 'en');
  this.renderer.appendChild(this.document.head, script2);

  // OptanonWrapper function
  const inlineScript = this.renderer.createElement('script');
  inlineScript.type = 'text/javascript';
  inlineScript.innerHTML = `function OptanonWrapper() { }`;
  this.renderer.appendChild(this.document.head, inlineScript);
}

  private insertChillScripts(): void {
    // otSDKStub.js
    const script1 = this.renderer.createElement('script');
    script1.type = 'text/javascript';
    script1.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script1.charset = 'UTF-8';
    script1.setAttribute('data-domain-script', '6a0b8d5e-7509-49a8-af58-38049bd04608-test');
    this.renderer.appendChild(this.document.head, script1);

    // Trustpilot script
    const script2 = this.renderer.createElement('script');
    script2.type = 'text/javascript';
    script2.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script2.async = true;
    this.renderer.appendChild(this.document.head, script2);

    // OptanonWrapper function
    const inlineScript = this.renderer.createElement('script');
    inlineScript.type = 'text/javascript';
    inlineScript.innerHTML = `function OptanonWrapper() { }`;
    this.renderer.appendChild(this.document.head, inlineScript);
  }
}
